import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface StatsReviewDraft {
  timeRange: string;
  metricFocus: string;
  comparisonGroup: string;
}

@Component({
  selector: 'app-stats',
  templateUrl: './stats.page.html',
  styleUrls: ['./stats.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class StatsPage {
  public statsSuggestions: any[] = [
    { icon: 'bi bi-graph-up', prompt: 'Show velocity trend for last 6 weeks' },
    { icon: 'bi bi-activity', prompt: 'Compare coverage vs failures' },
    { icon: 'bi bi-pie-chart', prompt: 'Top contributors this month' },
  ];

  public statsContext: any = {
    page: 'stats',
    purpose: 'Explore metrics, trends and insights across the project',
    metrics: [],
    timeRange: 'last_30_days',
    comparisons: [],
    outputs: ['Charts', 'Trend analysis', 'Highlights and anomalies']
  };

  public generatingStats = false;
  public statsError = '';
  public statsSuccess = '';
  public hasGeneratedStats = false;
  public statsDraft: StatsReviewDraft = {
    timeRange: '',
    metricFocus: '',
    comparisonGroup: '',
  };

  public readonly timeRangeOptions = ['Last 7 days', 'Last 30 days', 'Last quarter'];

  constructor() {}

  public async generateStatsReview(): Promise<void> {
    this.statsError = '';
    this.statsSuccess = '';
    this.hasGeneratedStats = false;

    if (!this.statsDraft.timeRange.trim()) {
      this.statsError = 'Select a time range before generating stats review.';
      return;
    }
    if (!this.statsDraft.metricFocus.trim()) {
      this.statsError = 'Enter a metric focus before generating stats review.';
      return;
    }

    this.generatingStats = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasGeneratedStats = true;
      this.statsSuccess = 'Stats review generated for selected scope.';
    } finally {
      this.generatingStats = false;
    }
  }
} 